import { useNavigate } from 'react-router-dom';
import { TeamMemberList } from '../components/features/team-members/TeamMemberList';
import { Button } from '@/components/ui/Button';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';

export const TeamMembersPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto space-y-6">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/')}
          className="inline-flex items-center gap-1"
        >
          <ChevronLeftIcon className="w-4 h-4" aria-hidden="true" />
          Back to Dashboard
        </Button>
        <TeamMemberList />
      </div>
    </div>
  );
};
